import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Select } from '@/components/ui/Select'
import type { ChangeEvent } from 'react'
import inputStyles from '../../styles/input.module.css'
import styles from './registration.module.css'

interface RegistrationBusinessFormProps {
  values: {
    companyName: string
    jobPosition: string
    currency: string
    budget: string
    companySize: string
  }
  // errors: Record<string, string>
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onSelectChange: (id: 'currency' | 'budget' | 'companySize', value: string) => void
  onNext: () => void
  onBack: () => void
  currencyOptions: { value: string; label: string }[]
  budgetOptions: { value: string; label: string }[]
  companySizeOptions: { value: string; label: string }[]
}

export const RegistrationBusinessForm = ({
  values,
  // errors,
  onChange,
  onSelectChange,
  onNext,
  onBack,
  currencyOptions,
  budgetOptions,
  companySizeOptions,
}: RegistrationBusinessFormProps) => {
  const isInvalid = !values.companyName.trim() || !values.jobPosition.trim() || !values.budget || !values.companySize
  return (
    <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
      <Input id="companyName" placeholder="Company Name" value={values.companyName} onChange={onChange} minLength={2} maxLength={50} />

      <Input id="jobPosition" placeholder="Job Position" value={values.jobPosition} onChange={onChange} minLength={2} maxLength={50} />

      <div className={inputStyles.doubleInputs}>
        <Select
          id="currency"
          placeholder="Currency"
          options={currencyOptions}
          value={values.currency}
          onChange={(value) => onSelectChange('currency', value)}
          // error={errors.currency}
        />
        <div style={{ width: '100%' }}>
          <Select
            id="budget"
            placeholder="Marketing Budget"
            options={budgetOptions}
            value={values.budget}
            onChange={(value) => onSelectChange('budget', value)}
            // error={errors.budget}
          />
        </div>
      </div>

      <Select
        id="companySize"
        placeholder="Company Size"
        options={companySizeOptions}
        value={values.companySize}
        onChange={(value) => onSelectChange('companySize', value)}
        // error={errors.companySize}
      />

      <div className={styles.buttonGroup}>
        <Button type="button" variant="outline" size="large" style={{ width: '100%' }} className={styles.backBtn} onClick={onBack}>
          Back
        </Button>
        <Button
          type="button"
          variant="fill"
          size="large"
          style={{ width: '100%' }}
          className={styles.submitBtn}
          disabled={isInvalid}
          onClick={onNext}
        >
          Next
        </Button>
      </div>
    </form>
  )
}
